module.exports = __webpack_public_path__ + "static/media/sodexo.403f2e95.png";